















import Vue from 'vue';
import Component from 'vue-class-component';
import EventBus from './event-bus/';
import { GeneralLang } from './lang/en/general';

@Component({
  components: {},
})

export default class App extends Vue {
  private lang: any = GeneralLang;
  private showToast: boolean = false;
  private toastType: string = '';
  private toastMessage: string = '';
  private autoDismiss: boolean = false;
  private timeout: any = 25000;
  private verticlePos: string = 'top';
  private horizontalPos: any = 'center';
  private mode: string = 'multi-line';

  public mounted() {
    EventBus.ToastEvent.$on('globalToast', (type, message, dismiss, timeout= null) => {
      this.showToast = true;
      this.toastType = type;
      this.toastMessage = message;
      this.autoDismiss = dismiss;
      this.timeout = timeout;

      if (this.autoDismiss) {
        setTimeout(() => {
          this.toastMessage = '';
          this.showToast = false;
        }, this.timeout);
      }
    });
  }

  get iconType() {
    return `material-icons icon ${this.toastType}`;
  }

  private toggleSnackBar() {
    this.showToast = !this.showToast;
  }

}
